import React, { Component } from 'react';

import Builder from './Builder';

export default class AncorBuilder extends Component {
    render() {
        return <Builder isAncor />;
    }
}
